import { parseISO, differenceInYears } from 'date-fns';
import {
  courseDiscountTypeByStates,
  courseDiscountsAges,
  additionalDriverDiscountsTypesByStates,
  seniorDiscountByAgeOnlyStates,
  courseDiscountTypes,
  communityDriveAvailableStates
} from '@ourbranch/lookups';

const fullTimeStudentAgeLimit = 23;

// MARK: full time student
export const canPersonBeFullTimeStudent = ({ driverOrPerson, driversOrPeople, rateControlDate }) => {
  const isPrimaryMarried = driversOrPeople.some((d) => {
    return d.isPrimary && d.maritalStatus === 'M';
  });
  const isSpouseOfPrimary = driverOrPerson.isCoApplicant && driverOrPerson.maritalStatus === 'M' && isPrimaryMarried;

  // Use age node if available, otherwise calculate age based on rateControlDate so it doesn't change midterm on a policy
  // since age is re-calculated on renewal
  let age;
  if (driverOrPerson.age !== undefined && driverOrPerson.age !== null) {
    age = driverOrPerson.age;
  } else {
    const birthDate = parseISO(driverOrPerson.dateOfBirth);
    const rateDate = parseISO(rateControlDate);
    age = differenceInYears(rateDate, birthDate);
  }

  // if under 23, and not primary, and not married to primary, then eligible for student discount
  const canBeFullTimeStudent = age < fullTimeStudentAgeLimit && !driverOrPerson.isPrimary && !isSpouseOfPrimary;

  return canBeFullTimeStudent;
};

// MARK: driving course
export const canPersonReceiveDrivingCourseDiscount = ({ driverOrPerson, state }) => {
  const today = new Date();
  const birthDate = new Date(driverOrPerson.dateOfBirth);
  const age = differenceInYears(today, birthDate);
  const drivingCourseDiscountType = courseDiscountTypeByStates[state];

  // check if there is a state specific age limit for the discount (different from Inexperienced)
  const canReceiveDrivingCourseDiscount =
    drivingCourseDiscountType &&
    drivingCourseDiscountType !== courseDiscountTypes.INEXPERIENCED &&
    (seniorDiscountByAgeOnlyStates[state]
      ? age >= seniorDiscountByAgeOnlyStates[state]
      : age >= courseDiscountsAges[state]);

  // check if there is a state specific age to calculate Inexperienced discount
  const canReceiveInexperiencedDrivingCourseDiscount =
    drivingCourseDiscountType &&
    drivingCourseDiscountType === courseDiscountTypes.INEXPERIENCED &&
    age - driverOrPerson.ageFirstLicensed < courseDiscountsAges[state];

  return {
    canReceiveDrivingCourseDiscount,
    canReceiveInexperiencedDrivingCourseDiscount,
    canReceiveAdditionalDrivingCourseDiscount: additionalDriverDiscountsTypesByStates[state]?.condition
  };
};

// MARK: community drive
export const canReceiveCommunityDriveDiscount = ({ state, isBix }) => {
  return (
    communityDriveAvailableStates[state] &&
    ((isBix && communityDriveAvailableStates[state].showForBix) ||
      (!isBix && communityDriveAvailableStates[state].showForNonBix))
  );
};
